module.exports = __webpack_public_path__ + "img/c6cf35116a634c7d1145d3e1283a8c96.546e072a.jpg";